import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { toolsDetailsJobsConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const ToolsDetailsJobStack = createStackNavigator();

const ToolsDetailsJobNavigator = () => {
  return (
    <ToolsDetailsJobStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {toolsDetailsJobsConfig.map(({ Component, name }) => (
        <ToolsDetailsJobStack.Screen key={name} name={name} component={Component} />
      ))}
    </ToolsDetailsJobStack.Navigator>
  );
};

export { ToolsDetailsJobNavigator };
